<template>
  <div>
    <el-form :model="value" ref="formRef" :rules="formRules" label-suffix=":" label-width="100px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="车场名称" prop="spaceId">
            <el-select
              v-model="value.spaceId"
              style="width: 100%"
              placeholder="请选择"
              disabled
              @change="projectIdChange"
            >
              <el-option
                v-for="item in spaceList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="车辆身份" prop="carManageType">
            <el-select
              v-model="value.carManageType"
              style="width: 100%"
              placeholder="请选择车辆身份"
              @change="carManageTypeChange"
            >
              <el-option
                v-for="item in carManageTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="车牌号" prop="plateNumber">
            <el-input
              clearable
              v-model="value.plateNumber"
              placeholder="请输入车牌号"
              @blur="plateNumberBlur"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="车型大小" prop="bigOrSmallCar">
            <el-select
              v-model="value.bigOrSmallCar"
              style="width: 100%"
              placeholder="请选择车型大小"
              @change="bigOrSmallCarChange"
            >
              <el-option
                v-for="item in bigOrSmallCarList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType != 4">
          <el-form-item label="主/副车" prop="isMainCar">
            <el-select
              v-model="value.isMainCar"
              style="width: 100%"
              placeholder="请选择主/副车"
              @change="isMainCarChange"
            >
              <el-option
                v-for="item in carCategoryList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :span="8"
          v-if="(value.carManageType == 1 || value.carManageType == 2) && value.isMainCar == 0"
        >
          <el-form-item label="关联主车" prop="mainPlateNumber">
            <el-input readonly :disabled="edit" v-model="value.mainPlateNumber">
              <el-button @click="selectCarOwner" slot="append" type="primary">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 2 && value.isMainCar == 1">
          <el-form-item label="车位编号" prop="parkingSpaceNames">
            <el-input
              ref="parkingSpaceNamesInput"
              readonly
              :disabled="edit"
              v-model="value.parkingSpaceNames"
            >
              <el-button @click="clearCarCode" slot="prepend" type="primary">清空</el-button>
              <el-button @click="selectCarCode" slot="append" type="primary">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车主" prop="personName">
            <el-input
              clearable
              v-model="value.personName"
              placeholder="请输入车主"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车主电话" prop="personPhone">
            <el-input
              clearable
              v-model="value.personPhone"
              placeholder="请输入车主电话"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="楼栋/单元"
            prop="buildingId"
            :rules="[{ required: false, message: '请选择楼栋/单元', trigger: 'blur' }]"
          >
            <el-select
              :disabled="edit"
              @change="buildingIdChange"
              v-model="value.buildingId"
              style="width: 100%"
            >
              <el-option
                style="padding-left: 10px"
                v-for="item in buildingList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="房间名称" prop="roomId" :rules="roomRule">
            <el-select
              :disabled="edit"
              @change="roomIdChange"
              v-model="value.roomId"
              style="width: 100%"
            >
              <el-option
                style="padding-left: 10px"
                v-for="item in roomList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="收费套餐" prop="feeRuleId">
            <el-select
              v-model="value.feeRuleId"
              style="width: 100%"
              placeholder="请选择收费套餐"
              :disabled="carRuleDisabled || (value.carManageType == 1 && value.isMainCar == 0)"
              @change="ruleIdChange"
            >
              <el-option
                v-for="item in ruleList"
                :key="item.id"
                :label="item.setmealName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="租赁起期" prop="effectTime">
            <el-date-picker
              :disabled="value.carManageType == 1 && value.isMainCar == 0"
              v-model="value.effectTime"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              align="right"
              type="date"
              placeholder="选择租赁起期"
              @change="effectTimeChange"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="租赁时长" prop="cycleNum">
            <el-select
              :disabled="value.carManageType == 1 && value.isMainCar == 0"
              v-model="value.cycleNum"
              style="width: 100%"
              placeholder="请选择租赁时长"
              @change="cycleNumChange"
            >
              <el-option
                v-for="item in cycleNumList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="租赁止期" prop="expiredTime">
            <el-date-picker
              v-model="value.expiredTime"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              disabled
              align="right"
              type="date"
              placeholder="选择租赁止期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="优惠方案" prop="discountRuleId">
            <el-select
              clearable
              v-model="value.discountRuleId"
              style="width: 100%"
              placeholder="请选择优惠方案"
              :disabled="discountRuleDisabled || (value.carManageType == 1 && value.isMainCar == 0)"
              @change="discountIdChange"
            >
              <el-option
                v-for="item in discountRuleList"
                :key="item.id"
                :label="item.discountName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="优惠金额" prop="discountAmount">
            <el-input
              clearable
              v-model="value.discountAmount"
              disabled
              placeholder=""
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="应收金额" prop="shouldAmount">
            <el-input
              clearable
              v-model="value.shouldAmount"
              placeholder=""
              disabled
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="实收金额" prop="payAmount">
            <el-input
              clearable
              disabled
              v-model="value.payAmount"
              placeholder=""
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="授权区域" prop="regions">
            <avue-input-tree
              style="width: 100%"
              :props="treeRegionProps"
              v-model="value.regions"
              placeholder="请选择授权区域"
              type="tree"
              multiple
              checkStrictly
              :dic="regionList"
              :disabled="value.isMainCar == 0"
            ></avue-input-tree>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="description">
            <el-input
              clearable
              v-model="value.description"
              type="textarea"
              :rows="2"
              placeholder="请输入备注"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float: right">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="saveRecord"
              size="small"
            >
              保存
            </el-button>
            <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
              取消
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <hr-dialog
      width="80%"
      :visible.sync="showCarCodeFlag"
      :title="'选择车位'"
      :handleClose="handleCloseCarCodeFlag"
    >
      <template slot="body">
        <div>
          <!-- dawdaw -->
          <!-- :form="registerForm" -->
          <parkvihicleCarCode
            v-if="showCarCodeFlag"
            :spaceId="value.spaceId"
            :carManageType="value.carManageType"
            :carId="value.id"
            @getCarCode="getCarCode"
          >
          </parkvihicleCarCode>
        </div>
      </template>
      <template slot="footer">
        <div class="btnArea" style="text-align: right; margin-right: 24px">
          <!-- v-if="isEdit" -->
          <el-button
            size="small"
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="selectConfirm"
            style="margin-right: 20px"
            >确定</el-button
          >
          <!-- v-if="isEdit" -->
          <el-button @click="closeCarCodeRecord" size="small" icon="el-icon-circle-close"
            >取消</el-button
          >

          <!-- v-if="cancelBtn" -->
        </div>
      </template>
    </hr-dialog>

    <hr-dialog
      width="80%"
      :visible.sync="showCarOwnerFlag"
      :title="value.carManageType == 2 ? '关联固停车主车' : '关联主车'"
      :handleClose="handleCloseCarOwnerFlag"
    >
      <template slot="body">
        <div>
          <!-- dawdaw -->
          <!-- :form="registerForm" -->
          <parkvihicleCarOwner
            v-if="showCarOwnerFlag"
            :spaceId="value.spaceId"
            :carManageType="value.carManageType"
            :carId="value.id"
            @getCarOwner="getCarOwner"
          >
          </parkvihicleCarOwner>
        </div>
      </template>
      <template slot="footer">
        <div class="btnArea" style="text-align: right; margin-right: 24px">
          <!-- v-if="isEdit" -->
          <el-button
            size="small"
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="selectCarOwnerConfirm"
            style="margin-right: 20px"
            >确定</el-button
          >
          <!-- v-if="isEdit" -->
          <el-button @click="closeCarOwnerRecord" size="small" icon="el-icon-circle-close"
            >取消</el-button
          >

          <!-- v-if="cancelBtn" -->
        </div>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import {
  addRegister,
  getBuildingList,
  getRoomList,
  getCarRuleList,
  calculateMonthCarFeeInFo,
  getCarRuleDiscountListNew,
  getManageDetail,
} from './parkvehicle';
import { nodeTreeByParentId} from '@/api/v4ward/carv2/carmonth';
import {
  getSpaceList,
  getInfoByPlateNumber,
} from '@/api/v4ward/carv2/carmonthquickRegistration';
import { getDictionary } from '@/api/common.js';
import { initEndTime } from '@/api/v4ward/carv2/carmonthchargerule';
import parkvihicleCarCode from '@/views/v4ward/park/vehiclev3/parkvehicle-carcode';
import parkvihicleCarOwner from '@/views/v4ward/park/vehiclev3/parkvehicle-carowner';
export default {
  components: {
    parkvihicleCarCode,
    parkvihicleCarOwner,
  },
  props: ['value'],
  data() {
    return {
      roomRule: [{ required: false, message: '请选择房间名称', trigger: 'blur' }],
      showCarOwnerFlag: false,
      showCarCodeFlag: false,
      regionList: [],
      buildingList: [],
      roomList: [],
      treeRegionProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      carManageTypeList: [],
      bigOrSmallCarList: [], //车辆类型
      carCategoryList: [], //车辆类别
      ruleList: [], //收费套餐
      discountRuleList: [], //优惠规则
      cycleNumList: [], //续租时长,
      spaceList: [], //车场
      carRuleDisabled: true,
      discountRuleDisabled: true,
      formRules: {
        spaceId: [{ required: true, message: '车场不能为空', trigger: 'blur' }],
        plateNumber: [
          { required: true, message: '车牌不能为空', trigger: 'blur' },
          {
            required: true,
            pattern: this.$validation.carPlate,
            message: '车牌格式不对',
            trigger: 'blur',
          },
        ],
        regions: [{ required: true, message: '区域不能为空', trigger: 'blur' }],
        personName: [{ required: true, message: '客户姓名不能为空', trigger: 'blur' }],
        personPhone: [
          { required: true, message: '客户手机不能为空', trigger: 'blur' },
          {
            required: true,
            pattern: this.$validation.phone,
            message: '请输入正确的手机号',
            trigger: 'change',
          },
        ],
        carManageType: [{ required: true, message: '车辆身份不能为空', trigger: 'blur' }],
        isMainCar: [{ required: true, message: '车辆类别不能为空', trigger: 'blur' }],
        bigOrSmallCar: [{ required: true, message: '车辆类型不能为空', trigger: 'blur' }],
        feeRuleId: [{ required: true, message: '收费套餐不能为空', trigger: 'blur' }],
        // discountRuleId: [{ required: true, message: '优惠规则不能为空', trigger: 'blur' }],
        effectTime: [{ required: true, message: '租赁起期不能为空', trigger: 'blur' }],
        cycleNum: [{ required: true, message: '续租时长不能为空', trigger: 'blur' }],
        parkingSpaceNames: [{ required: true, message: '车位编号不能为空', trigger: 'change' }],
        mainPlateNumber: [{ required: true, message: '关联主车不能为空', trigger: 'change' }],
      },
    };
  },
  created() {
    console.log('快速注册', this.value);
    this.initData();
  },
  watch: {
    'value.carManageType'(val) {
      if (val == 4) {
        this.roomRule[0].required = true;
      } else {
        this.roomRule[0].required = false;
      }
    },
  },
  methods: {
    roomIdChange(val) {
      this.roomList.forEach((ele) => {
        if (ele.value == val) {
          this.value.roomName = ele.label;
        }
      });
    },
    getCarOwner(val) {
      console.log(val);
      this.value.mainCarId = val[0];
      this.value.mainPlateNumber = val[1];
      console.log(this.value.mainCarId.split(',').length);
      if (!this.value.mainCarId) {
        return;
      }
      if (this.value.mainCarId && this.value.mainCarId.split(',').length > 1) {
        this.value.mainCarId = '';
        this.value.mainPlateNumber = '';
        this.$message.warning('请选择一条数据');
        return;
      }
      this.value = this._.cloneDeep(this.value);
      getManageDetail({ id: val[0] }).then((res) => {
        this.value.feeRuleId = res.data.feeRuleId;
        this.value.cycleNum = res.data.cycleNum;
        this.value.discountRuleId = res.data.discountRuleId;
        this.value.shouldAmount = res.data.shouldAmount;
        this.value.payAmount = res.data.payAmount;
        this.value.discountAmount = res.data.discountAmount;
        this.value.personName = res.data.personName;
        this.value.personPhone = res.data.personPhone;
        this.value.buildingId = res.data.buildingId;
        this.buildingIdChange(this.value.buildingId);
        this.value.roomId = res.data.roomId;
        this.value.roomName = res.data.roomName;
        this.value.regions = res.data.regionIds.split(',');
        if (this.value.carManageType == 1) {
          this.value.effectTime = res.data.effectTime;
          this.value.expiredTime = res.data.expiredTime;
          getCarRuleList({
            spaceId: this.value.spaceId,
            packageType: this.value.carManageType,
            bigOrSmallCar: this.value.bigOrSmallCar,
          }).then((res) => {
            this.ruleList = res.data;
          });

          getCarRuleDiscountListNew({
            spaceId: this.value.spaceId,
            payPeriods: this.value.cycleNum,
            carFeeRuleId: this.value.feeRuleId,
          }).then((res) => {
            this.discountRuleList = res.data;
          });
        }
        console.log('getManageDetail=============>', res.data);
      });
    },
    selectCarOwner() {
      this.showCarOwnerFlag = true;
    },
    selectCarOwnerConfirm() {
      // console.log('selectCarOwnerConfirm',);
      if (!this.value.mainCarId) {
        this.$message.warning('请选择一条数据');
        return;
      }
      if (this.value.mainCarId && this.value.mainCarId.split(',').length > 1) {
        this.value.mainCarId = '';
        this.value.mainPlateNumber = '';
        this.$message.warning('请选择一条数据');
        return;
      }
      this.showCarOwnerFlag = false;
    },
    closeCarOwnerRecord() {
      // this.regForm.regionNames = '';
      // this.regForm.parkingSpaceIds = '';
      this.showCarOwnerFlag = false;
    },
    handleCloseCarOwnerFlag() {
      this.closeCarOwnerRecord();
    },
    buildingIdChange(val,flag) {
      let this_ = this;
      console.log('快速登记=====buildingId======>');
      if(!flag){
        this.value.roomId = '';
        this.value = this._.cloneDeep(this_.value);
      }
      getRoomList({ buildingId: val }).then((res) => {
        this.roomList = res.data;
      });
    },
    getCarCode(val) {
      console.log(val);
      if (this.value.carManageType == 2) {
        this.value.parkingSpaceIds = val[0];
        this.value.parkingSpaceNames = val[1];
      }
      if (this.value.carManageType == 1) {
        this.value.parkingSpaceIds_ = val[0];
        this.value.parkingSpaceNames_ = val[1];
      }
      this.value = this._.cloneDeep(this.value);
      console.log(this.value.parkingSpaceNames);
      setTimeout(() => {
        this.$refs.parkingSpaceNamesInput.blur();
        console.log(this.$refs.parkingSpaceNamesInput);
      });
    },
    selectConfirm() {
      this.showCarCodeFlag = false;
    },
    closeCarCodeRecord() {
      this.showCarCodeFlag = false;
    },
    handleCloseCarCodeFlag() {
      this.closeCarCodeRecord();
    },
    selectCarCode() {
      this.showCarCodeFlag = true;
    },
    clearCarCode() {
      this.value.parkingSpaceIds = '';
      this.value.parkingSpaceNames = '';
      this.value.parkingSpaceIds_ = '';
      this.value.parkingSpaceNames_ = '';
    },
    discountIdChange() {
      this.value = _.cloneDeep(this.value);
      this.computeMoney();
    },
    effectTimeChange() {
      this.computeMoney();
      // this.getEndTime();
    },
    ruleIdChange() {
      this.value.discountRuleId = '';
      this.value = this._.cloneDeep(this.value);
      if (this.value.cycleNum && this.value.feeRuleId) {
        this.discountRuleDisabled = false;
        this.getDiscountList();
      }
      this.computeMoney();
    },
    cycleNumChange() {
      this.value.discountRuleId = '';
      // this.getEndTime();
      if (this.value.cycleNum && this.value.feeRuleId) {
        this.discountRuleDisabled = false;
        this.getDiscountList();
      }
      this.computeMoney();
    },
    isMainCarChange() {
      let self = this;
      this.value.feeRuleId = '';
      this.value.discountRuleId = '';
      this.$refs.formRef.clearValidate();
      if (this.value.bigOrSmallCar && this.value.isMainCar) {
        this.carRuleDisabled = false;
      }
    },
    carManageTypeChange(val) {
      this.value = {
        spaceId: this.value.spaceId,
        carManageType: this.value.carManageType,
        isMainCar: this.carCategoryList[1].dictKey,
      };
    },
    bigOrSmallCarChange() {
      if (this.value.bigOrSmallCar && this.value.isMainCar) {
        this.carRuleDisabled = false;

        getCarRuleList({
          spaceId: this.value.spaceId,
          packageType: this.value.carManageType,
          bigOrSmallCar: this.value.bigOrSmallCar,
        }).then((res) => {
          this.ruleList = res.data;
          this.carRuleDisabled = false;
        });
      }
    },
    plateNumberBlur() {
      getInfoByPlateNumber({
        spaceId: this.value.spaceId,
        plateNumber: this.value.plateNumber,
      }).then((res) => {
        if(JSON.stringify(res.data)==='{}'){
          return;
        }
        this.value.bigOrSmallCar = res.data.bigOrSmallCar;
        this.value.isMainCar = 1;
        this.value.personName = res.data.personName;
        this.value.personPhone = res.data.personPhone;
        this.value.buildingId = res.data.buildingId;
        this.value.roomId = res.data.roomId;
        this.value.roomName = res.data.roomName;
        this.value.regions = res.data.regionIds.split(',');
        this.buildingIdChange(this.value.buildingId,1);
        getCarRuleList({
          spaceId: this.value.spaceId,
          packageType: this.value.carManageType,
          bigOrSmallCar: this.value.bigOrSmallCar,
        }).then((res) => {
          this.ruleList = res.data;
          this.carRuleDisabled = false;
        });
        this.value = this._.cloneDeep(this.value);
      });
    },
    initData() {
      this.getSpaceList();
      this.getRegion(this.value.spaceId);
      this.getCarCategory();
      this.getbigOrSmallCar();
      this.getCycleNumList();
      this.getCarManageType();
      this.getBuildingListHandler(this.value.spaceId);
    },
    getBuildingListHandler() {
      getBuildingList({ spaceId: this.value.spaceId }).then((res) => {
        this.buildingList = res.data;
      });
    },
    getSpaceList() {
      getSpaceList().then((res) => {
        this.spaceList = res.data;
      });
    },
    //获取区域
    getRegion(id) {
      nodeTreeByParentId(id).then((res) => {
        this.regionList = res.data;
      });
    },

    //获取车辆类别(车主类别)
    getCarManageType() {
      getDictionary('car_manage_type').then((res) => {
        let tempIndex = '';
        res.data.forEach((ele, i) => {
          if (ele.dictValue === '储值车') {
            tempIndex = i;
          }
        });
        res.data.splice(tempIndex, 1);
        console.log('res.data=========>', res.data);
        this.carManageTypeList = res.data;
      });
    },
    //获取车辆类别(车主类别)
    getCarCategory() {
      getDictionary('car_category_v2').then((res) => {
        // this.carCategoryList = res.data;
        this.carCategoryList = [
          {
            dictValue: '副车',
            dictKey: 0,
          },
          {
            dictValue: '主车',
            dictKey: 1,
          },
        ];
      });
    },
    //车辆类型
    getbigOrSmallCar() {
      getDictionary('car_type_v2').then((res) => {
        this.bigOrSmallCarList = res.data;
      });
    },
    //获取续租时长
    getCycleNumList() {
      getDictionary('park_fee_cycle').then((res) => {
        this.cycleNumList = res.data;
      });
    },
    //获取优惠规则
    getDiscountList() {
      this.discountRuleDisabled = true;
      getCarRuleDiscountListNew({
        spaceId: this.value.spaceId,
        payPeriods: this.value.cycleNum,
        carFeeRuleId: this.value.feeRuleId,
      }).then((res) => {
        this.discountRuleList = res.data;
        this.discountRuleDisabled = false;
      });
    },
    //获取止期
    getEndTime() {
      if (this.value.cycleNum && this.value.effectTime) {
        initEndTime(
          Object.assign({
            cycleNum: this.value.cycleNum,
            startTime: this.value.effectTime,
          })
        ).then(({ data }) => {
          if (data) {
            this.value.expiredTime = data.endTime;
          }
        });
      }
    },
    //算钱
    computeMoney() {
      console.log(
        'aaa======feeRuleId=====>',
        this.value.feeRuleId,
        this.value.cycleNum,
        this.value.effectTime
      );

      if (
        this.value.cycleNum + '' !== 'undefined' &&
        this.value.feeRuleId + '' !== 'undefined' &&
        this.value.effectTime + '' !== 'undefined'
      ) {
        // this.getDiscountList();
        calculateMonthCarFeeInFo({
          feeRuleId: this.value.feeRuleId,
          spaceId: this.value.spaceId,
          cycleNum: this.value.cycleNum,
          discountRuleId: this.value.discountRuleId,
          effectTime: this.dayjs(this.value.effectTime).format('YYYY-MM-DD HH:mm:ss'),
        }).then((res) => {
          this.value.shouldAmount = res.data.shouldAmount;
          this.value.discountAmount = res.data.discountAmount;
          this.value.payAmount = res.data.payAmount;
          if (this.value.cycleNum && this.value.effectTime) {
            this.value.expiredTime = res.data.feeEndTime;
          }

          this.value = this._.cloneDeep(this.value);
        });
      }
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if (this.value.effectTime && this.value.expiredTime) {
            this.value.effectTime = this.dayjs(this.value.effectTime).format('YYYY-MM-DD HH:mm:ss');
            this.value.expiredTime = this.dayjs(this.value.expiredTime).format(
              'YYYY-MM-DD HH:mm:ss'
            );
          }
          console.log(this.value.regions);
          this.value.shouldAmount = this.value.shouldAmount || '0';
          this.value.regionIds = this.value.regions.join(',');
          if (this.value.parkingSpaceIds_ && this.value.parkingSpaceNames_) {
            this.value.parkingSpaceIds = this.value.parkingSpaceIds_;
            this.value.parkingSpaceNames = this.value.parkingSpaceNames_;
          }
          addRegister(this.value).then((res) => {
            this.$message.success('新增成功');
            this.$emit('success');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancleRecord() {
      console.log('触发关闭');
      this.$confirm('是否关闭继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('cancle');
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
  },
};
</script>
<style scoped>
::v-deep .el-col-8 {
  height: 54px;
}
</style>
